import { render, staticRenderFns } from "./AddShift.vue?vue&type=template&id=2ffb71f2"
import script from "./AddShift.vue?vue&type=script&lang=js"
export * from "./AddShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports